<div class="row">
  <div class="col-md-12">
    <div class="card mb-0">
      <div class="card-header d-flex">
        <h3 class="flex-grow-1">Especialista: {{ datos.nombre }}</h3>
        <button
          type="button"
          class="btn-close flex-shrink-0"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 showCalendar">
            <div class="calendar-container">
              <full-calendar
                #fullcalendar
                [options]="calendarOptions"
                [deepChangeDetection]="true"
              ></full-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #confirmModal let-modal>
  <div #modalContainer class="">
    <div class="modal-header">
      <h5 class="modal-title" id="modal-title">
        <i class="dripicons-user-id"></i>
        <small
          style="font-size: 10px; margin-left: 10px; margin-right: 5px"
          class="text-muted"
          >Especialista:</small
        >
        {{ datos.nombre }}
      </h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formData" (ngSubmit)="confirmarCita()">
        <div class="row">
          <div class="col-md-12">
            <p class="text-muted font-size-13 mb-1">
              <span>
                <i class="dripicons-user"></i> <strong> Paciente: </strong>
                {{ datosConfirmar.paciente }}
              </span>
            </p>
            <p class="text-muted font-size-13 mb-1">
              <span>
                <i class="dripicons-alarm"></i><strong> Hora: </strong>
                {{ datosConfirmar.fechaCitaFormateada }}
              </span>
            </p>
            <p class="text-muted font-size-13 mb-1">
              <span>
                <i class="dripicons-location"></i> <strong> Sede: </strong>
                {{ datosConfirmar.nombresede }}
              </span>
              <span> - {{ datosConfirmar.direccionSede }}</span>
              <br /><span>
                <strong>Consultorio: </strong> {{ datosConfirmar.consultorio }}
              </span>
            </p>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <p class="text-muted font-size-13 mb-1">
                  <span>
                    <p class="text-muted font-size-13 mb-1">
                      <span><strong>Modalidad: </strong></span>
                    </p>

                    <div>
                      <div *ngIf="datosConfirmar.idSede != 'online'" class="">
                        <input
                          class="form-check-input m-1"
                          type="radio"
                          (change)="changeModalidad($event)"
                          formControlName="modalidad"
                          name="modalidad"
                          value="Presencial"
                          id="modalidad1"
                          checked
                        />
                        <label class="form-check-label" for="formRadios1">
                          Presencial</label
                        >
                      </div>
                      <div *ngIf="datosConfirmar.idSede == 'online'" class="">
                        <input
                          class="form-check-input m-1"
                          type="radio"
                          (change)="changeModalidad($event)"
                          formControlName="modalidad"
                          name="modalidad"
                          value="Online"
                          id="formRadios2"
                        />
                        <label class="form-check-label" for="formRadios2"
                          >Online</label
                        >
                      </div>
                    </div>
                  </span>
                </p>
              </div>
              <div class="col-md-5">
                <p class="text-muted font-size-13 mb-1">
                  <span>
                    Duración de la cita: <br /><strong
                      >{{ duracionCita }} Minutos</strong
                    >
                    <input
                      style="display: none"
                      class="form-control m-1"
                      type="text"
                      readonly
                      formControlName="duracion"
                      name="modalidad"
                    />
                  </span>
                </p>
              </div>
              <div class="col-md-12">
                <p class="text-muted font-size-13 mb-1">
                  <span><strong>Servicio:</strong></span>
                </p>
                <ng-select
                  [items]="servicios"
                  bindValue="$id"
                  bindLabel="servicio"
                  placeholder="Seleccione"
                  appendTo="body"
                  [multiple]="false"
                  formControlName="servicio"
                  class="mb-2"
                  (change)="changeServicio($event)"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.servicio }} | {{ item.tConsulta?.tipo }}
                  </ng-template>
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-index="index"
                    let-search="searchTerm"
                  >
                    <div style="margin: 5px 0" class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ item.servicio }}</h5>
                        <h6 class="card-subtitle mb-2 text-muted">
                          <small>Duración:</small> {{ item.duracion }} Min
                        </h6>
                        <h6 class="card-subtitle mb-2 text-muted">
                          <small>Modalidad:</small> {{ item.modalidad }}
                        </h6>
                        <h6 class="card-subtitle mb-2 text-muted text-wrap">
                          <small>Tipo:</small> {{ item.tConsulta.tipo }}
                        </h6>
                      </div>
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="submitted && form.servicio.errors"
                  class="invalid-feedback"
                >
                  <span *ngIf="form.servicio.errors.required"
                    >Este campo es obligatorio</span
                  >
                </div>
              </div>
              <div class="col-md-12" *ngIf="datos.datosPaciente.idConvenio">
                <div class="card" style="margin: 5px 0">
                  <div class="card-body">
                    <h5 class="card-title">
                      {{ datos.datosPaciente.idConvenio.nombreConvenio }}
                    </h5>
                    <!-- <h6 class="card-subtitle mb-2 text-muted">
                      <small>Descuento:</small>
                      {{ datos.datosPaciente.idConvenio.descuento }} %
                    </h6> -->
                    <div
                      class="card-text text-danger"
                      *ngIf="datos.datosPaciente.idConvenio.requiereAprobacion"
                    >
                      SI Requiere aprobación
                    </div>
                    <div
                      class="card-text text-success"
                      *ngIf="!datos.datosPaciente.idConvenio.requiereAprobacion"
                    >
                      AUTORIZADO
                    </div>
                    <!-- <small>Finaliza: </small>{{datos.datosPaciente.idConvenio.fFinalizacionConvenio | date:'dd/MM/yyyy' }} -->
                    <hr />
                    <p class="text-muted font-size-13 mb-1">
                      <span>
                        <strong>Aplicar convenio: </strong>
                      </span>
                    </p>

                    <div class="d-flex">
                      <div>
                        <input
                          class="form-check-input m-1"
                          type="radio"
                          formControlName="convenio"
                          name="convenio"
                          value="NO"
                          id="noConvenio"
                          (change)="selectConvenio($event)"
                        />
                        <label class="form-check-label" for="noConvenio"
                          >No</label
                        >
                      </div>
                      <div>
                        <input
                          class="form-check-input m-1"
                          type="radio"
                          formControlName="convenio"
                          name="convenio"
                          value="SI"
                          id="siConvenio"
                          (change)="selectConvenio($event)"
                        />
                        <label class="form-check-label" for="siConvenio"
                          >Si</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="text-muted font-size-13 mb-1">
              <span>
                <p class="text-muted font-size-13 mb-1">
                  <span><strong>Detalle / Motivo de consulta: </strong></span>
                </p>
                <textarea
                  class="form-control"
                  id="commentmessage-input"
                  rows="1"
                  formControlName="detalle"
                ></textarea>
                <div scope="row" colspan="2" class="border-0 text-end">
                  Valor Total de la consulta
                </div>
                <div class="border-0 text-end">
                  <h4 class="m-0">$ {{ valorTotal | number }}</h4>
                </div>
              </span>
            </p>
            <hr />

            <div class="text-end mt-2">
              <button
                type="button"
                class="btn btn-light me-1"
                (click)="modal.dismiss('Cross click')"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-success"
                id="btn-save-event"
                (click)="confirmarCita()"
              >
                Agendar Cita
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- end modal dialog-->
  </div>
</ng-template>

<app-payment-form></app-payment-form>
